module.exports = __webpack_public_path__ + "static/media/quick_service_layout__.2aabad6f.png";